<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Sellos / Firmas</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Configuraciones</span>
    </div>
  </div>
  @if (!usuarioSeleccionado) {
    <div class="d-flex my-xl-auto right-content align-items-center gap-2">
      <button class="btn btn-outline-secondary btn-sm" (click)="cargarUsuarios()" [disabled]="cargando">
        <i class="bi bi-arrow-clockwise me-1"></i> Actualizar
      </button>
    </div>
  }
</div>

<!-- ------------------------------------------------------------------ -->
<!-- Lista de usuarios                                                   -->
<!-- ------------------------------------------------------------------ -->
@if (!usuarioSeleccionado) {
  <div class="row">
    <div class="col-md-12">
      @if (cargando) {
        <div class="text-center py-4">
          <div class="spinner-grow text-primary" role="status"></div>
          <p class="mt-2 text-muted">Cargando usuarios…</p>
        </div>
      }
      @if (!cargando) {
        <div class="card">
          <h6 class="card-title text-uppercase p-2 text-white mb-1" style="background-color:#2E3D8C">
            Usuarios con servicios de informe
          </h6>
          <div class="card-body">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                class="table table-bordered table-striped table-hover dt-ext">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Usuario</th>
                    <th>Perfil</th>
                    <th>Sello</th>
                    <th>Firma .p12</th>
                    <th>Última actualización</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  @for (u of usuarios; track u; let i = $index) {
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>
                        <div class="fw-semibold">{{ u.nombre }}</div>
                        <small class="text-muted">{{ u.usuario }}</small>
                      </td>
                      <td>
                        <span class="badge bg-secondary">{{ u.perfil | uppercase }}</span>
                      </td>
                      <td>
                        @if (u.sello_url) {
                          <span class="badge bg-success">
                            <i class="bi bi-check-circle me-1"></i>Configurado
                          </span>
                        }
                        @if (!u.sello_url) {
                          <span class="badge bg-warning text-dark">
                            <i class="bi bi-dash-circle me-1"></i>Pendiente
                          </span>
                        }
                      </td>
                      <td>
                        @if (u.firma_p12_url) {
                          <span class="badge bg-success">
                            <i class="bi bi-check-circle me-1"></i>Configurado
                          </span>
                        }
                        @if (!u.firma_p12_url) {
                          <span class="badge bg-warning text-dark">
                            <i class="bi bi-dash-circle me-1"></i>Pendiente
                          </span>
                        }
                      </td>
                      <td>
                        <small class="text-muted">
                          {{ u.firma_actualizada ? (u.firma_actualizada | date:'dd/MM/yyyy HH:mm') : '—' }}
                        </small>
                      </td>
                      <td>
                        <button class="btn btn-primary btn-sm" (click)="seleccionarUsuario(u)">
                          <i class="bi bi-pencil-square me-1"></i>Configurar
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- ------------------------------------------------------------------ -->
<!-- Formulario de edición                                               -->
<!-- ------------------------------------------------------------------ -->
@if (usuarioSeleccionado) {
  <div class="row">
    <div class="col-12 col-lg-8 mx-auto">
      <div class="card">
        <div class="card-header d-flex align-items-center">
          <button class="btn btn-sm btn-outline-secondary me-3" (click)="cancelar()">
            <i class="bi bi-arrow-left"></i>
          </button>
          <h5 class="mb-0">
            <i class="bi bi-person-badge me-2"></i>
            Configurar: <strong>{{ usuarioSeleccionado.nombre }}</strong>
          </h5>
        </div>
        <div class="card-body">
          <!-- Imagen del sello -->
          <div class="mb-4">
            <label class="form-label fw-semibold">
              <i class="bi bi-image me-1"></i>Imagen del sello
            </label>
            @if (sello_url) {
              <div class="mb-2">
                <img [src]="sello_url" alt="Sello" class="img-sello-preview rounded border" />
                <small class="d-block text-success mt-1">
                  <i class="bi bi-check-circle me-1"></i>Sello cargado
                </small>
              </div>
            }
            <div class="input-group">
              <input type="file" class="form-control" accept="image/jpeg,image/png,image/webp"
                (change)="onSelloChange($event)" [disabled]="subiendoSello" />
              @if (subiendoSello) {
                <span class="input-group-text">
                  <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                </span>
              }
            </div>
            <small class="text-muted">Formatos: JPG, PNG, WEBP.</small>
          </div>
          <hr />
          <!-- Archivo .p12 -->
          <div class="mb-4">
            <label class="form-label fw-semibold">
              <i class="bi bi-file-earmark-lock2 me-1"></i>Firma electrónica (.p12)
            </label>
            @if (firma_p12_url) {
              <div class="alert alert-success py-2 px-3 mb-2">
                <i class="bi bi-check-circle me-1"></i>
                Archivo .p12 cargado.
                <a [href]="firma_p12_url" target="_blank" class="ms-2">
                  <i class="bi bi-download me-1"></i>Descargar
                </a>
              </div>
            }
            <div class="input-group">
              <input type="file" class="form-control" accept=".p12,application/x-pkcs12"
                (change)="onFirmaP12Change($event)" [disabled]="subiendoFirma" />
              @if (subiendoFirma) {
                <span class="input-group-text">
                  <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                </span>
              }
            </div>
            <small class="text-muted">Solo archivos con extensión <code>.p12</code>.</small>
          </div>
          <hr />
          <!-- Clave del .p12 -->
          <div class="mb-4">
            <label class="form-label fw-semibold">
              <i class="bi bi-key me-1"></i>Clave del .p12
            </label>
            <input type="password" class="form-control" [(ngModel)]="clave_p12"
              placeholder="Dejar en blanco para no cambiar la clave actual"
              autocomplete="new-password" />
            <small class="text-muted">Se cifra antes de almacenarse. Solo complete si desea actualizar la clave.</small>
          </div>
          <hr />
          <!-- Datos adicionales -->
          <div class="mb-4">
            <label class="form-label fw-semibold">
              <i class="bi bi-card-text me-1"></i>Datos adicionales
            </label>
            <textarea class="form-control" rows="4" [(ngModel)]="datos_adicionales"
            placeholder="Nombre del firmante, cargo, institución, RUC, etc."></textarea>
            <small class="text-muted">Texto libre con información adicional que aparecerá en los informes.</small>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end gap-2">
          <button class="btn btn-secondary" (click)="cancelar()" [disabled]="guardando">
            <i class="bi bi-x-circle me-1"></i>Cancelar
          </button>
          <button class="btn btn-success" (click)="guardar()"
            [disabled]="guardando || subiendoSello || subiendoFirma">
            @if (guardando) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            }
            @if (!guardando) {
              <i class="bi bi-floppy me-1"></i>
            }
            {{ guardando ? 'Guardando…' : 'Guardar configuración' }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
